import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Enum_Bookmark_Category, KnowledgeBase } from '@edwin-group/people-graphql';
import KnowledgeBaseCard from '@/components/KnowledgeBaseCard';
import useBookmark from '@/components/Bookmark/useBookmark';

export interface KnowledgeBaseBookmarkCardProps {
  knowledgebase: KnowledgeBase;
  onRemoveFromBookmark?: () => void;
  removeFromBookmarksText: string;
  openButtonTxt: string;
}

export function KnowledgeBaseBookmarkCard({
  knowledgebase,
  onRemoveFromBookmark,
  removeFromBookmarksText,
  openButtonTxt,
}: KnowledgeBaseBookmarkCardProps) {
  const { handleClick } = useBookmark({ relationId: knowledgebase.documentId || '' });

  const buttonContent = useMemo(
    () => (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <Link
          to={`/knowledge-base/${knowledgebase.slug}`}
          className="font-haffer text-sh-12-18 font-bold text-dark-green hover:underline"
          aria-label={`Knowledge base: ${knowledgebase.title}`}>
          {openButtonTxt}
        </Link>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handleClick(
              knowledgebase,
              knowledgebase.knowledgeBaseType?.documentId || '',
              Enum_Bookmark_Category.KnowledgeBase,
              onRemoveFromBookmark,
            );
          }}
          className="cursor-pointer border-0 bg-transparent p-0 font-haffer text-sh-12-18 font-bold text-dark-green hover:underline">
          {removeFromBookmarksText}
        </button>
      </div>
    ),
    [knowledgebase, openButtonTxt, removeFromBookmarksText, handleClick, onRemoveFromBookmark],
  );

  return (
    <KnowledgeBaseCard
      title={knowledgebase.title || ''}
      description={knowledgebase.briefDescription || ''}
      thumbnail={knowledgebase.cover || undefined}
      url={`/knowledge-base/${knowledgebase.slug}`}
      duration={knowledgebase.duration || undefined}
      tag={knowledgebase.knowledgeBaseType?.type?.toString() || undefined}
      button={buttonContent}
    />
  );
}
